module.exports = __webpack_public_path__ + "static/media/icn_crousal_card1.54d3d730.svg";